import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { catchError, filter, map, mergeMap, of } from 'rxjs';
import { imageBlockActions } from '../actions/image-block.actions';
import { selectLoading } from '../selectors/image-block.selector';
import { HttpService } from '../services/http.service';

@Injectable()
export class ImageBlockEffects {
    private readonly store = inject(Store);
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getImage$ = createEffect(() => {
        return this.actions.pipe(
            ofType(imageBlockActions.getImage),
            concatLatestFrom(({ id }) => this.store.select(selectLoading(id))),
            filter(([, loading]) => loading === null),
            mergeMap(([action]) => {
                return this.httpService.getImage(action.id).pipe(
                    map((payload) => imageBlockActions.getImageSuccess({ payload })),
                    catchError((error) => of(imageBlockActions.getImageError({ id: action.id, code: error.status }))),
                );
            }),
        );
    });

    getImageSetLoading$ = createEffect(() => {
        return this.actions.pipe(
            ofType(imageBlockActions.getImage),
            concatLatestFrom(({ id }) => this.store.select(selectLoading(id))),
            filter(([, loading]) => loading === null),
            map(([action]) => imageBlockActions.setLoading({ id: action.id })),
        );
    });
}
